import logos from '@/assets/logos.svg'
import manifest from '@/assets/logos/manifest.json'

// Import all individual SVG files for logos that need direct rendering
// (those with gradients, embedded images, or other features that don't work with <use>)
const svgFiles = import.meta.glob('../assets/logos/*.svg', {
  eager: true,
  query: '?url',
  import: 'default'
}) as Record<string, string>

// Create a map from logo name to its URL
const logoUrls: Record<string, string> = {}
for (const [path, url] of Object.entries(svgFiles)) {
  const name = path.split('/').pop()?.replace('.svg', '')
  if (name) logoUrls[name] = url
}

export type Props = {
  className?: string
  name: Name
  ariaLabel?: string
}

type Name =
  | 'aimventory'
  | 'aimventory-darkmode'
  | 'atuin-darkmode'
  | 'atuin'
  | 'astral-darkmode'
  | 'astral'
  | 'autumn-darkmode'
  | 'autumn'
  | 'barstool-darkmode'
  | 'barstool'
  | 'bento'
  | 'bento-darkmode'
  | 'blacksmith'
  | 'blacksmith-darkmode'
  | 'buttondown'
  | 'capy'
  | 'capy-darkmode'
  | 'cash-app'
  | 'cash-app-darkmode'
  | 'classdojo-darkmode'
  | 'classdojo'
  | 'clay'
  | 'clay-darkmode'
  | 'clearstream'
  | 'clearstream-darkmode'
  | 'cloudflare'
  | 'cloudflare-darkmode'
  | 'clerk-darkmode'
  | 'clerk'
  | 'community-darkmode'
  | 'community'
  | 'conductor'
  | 'conductor-darkmode'
  | 'convex-darkmode'
  | 'convex'
  | 'cursor-darkmode'
  | 'cursor'
  | 'dat'
  | 'dat-darkmode'
  | 'day-ai'
  | 'day-ai-darkmode'
  | 'delphi'
  | 'delphi-darkmode'
  | 'depot'
  | 'depot-darkmode'
  | 'dub'
  | 'dub-darkmode'
  | 'entire'
  | 'entire-darkmode'
  | 'etsy'
  | 'everai'
  | 'everai-darkmode'
  | 'executor'
  | 'executor-darkmode'
  | 'fathom'
  | 'fathom-darkmode'
  | 'fin'
  | 'fin-darkmode'
  | 'firecrawl'
  | 'firecrawl-darkmode'
  | 'flyclops'
  | 'flyclops-darkmode'
  | 'gigaml'
  | 'gigaml-darkmode'
  | 'gitbutler'
  | 'gitbutler-darkmode'
  | 'greptile'
  | 'greptile-darkmode'
  | 'grok-bot'
  | 'grok-bot-darkmode'
  | 'gusto'
  | 'haloai'
  | 'haloai-darkmode'
  | 'helix'
  | 'helix-darkmode'
  | 'heygen'
  | 'heygen-darkmode'
  | 'hoplite'
  | 'hoplite-darkmode'
  | 'inngest'
  | 'inngest-darkmode'
  | 'inth'
  | 'inth-darkmode'
  | 'intercom'
  | 'intercom-darkmode'
  | 'kick'
  | 'kernel'
  | 'kernel-darkmode'
  | 'laravel'
  | 'layers'
  | 'layers-darkmode'
  | 'lime'
  | 'lmnt'
  | 'lmnt-darkmode'
  | 'lugg'
  | 'lugg-darkmode'
  | 'magicare'
  | 'magicare-darkmode'
  | 'may'
  | 'may-darkmode'
  | 'mercor'
  | 'mixedbread'
  | 'mixedbread-darkmode'
  | 'mixpanel'
  | 'mixpanel-darkmode'
  | 'mintify'
  | 'mintify-darkmode'
  | 'mora'
  | 'mora-darkmode'
  | 'mothership'
  | 'mothership-darkmode'
  | 'myfitnesspal-darkmode'
  | 'myfitnesspal'
  | 'notion'
  | 'notion-darkmode'
  | 'octolens'
  | 'octolens-darkmode'
  | 'opencode'
  | 'opencode-darkmode'
  | 'opensecret'
  | 'opensecret-darkmode'
  | 'orb'
  | 'orb-darkmode'
  | 'owner'
  | 'owner-darkmode'
  | 'peregrine'
  | 'peregrine-darkmode'
  | 'photon'
  | 'photon-darkmode'
  | 'poke'
  | 'poke-darkmode'
  | 'polar'
  | 'polar-darkmode'
  | 'pocket'
  | 'pocket-darkmode'
  | 'primitive'
  | 'proximal-labs'
  | 'proximal-labs-darkmode'
  | 'profound'
  | 'profound-darkmode'
  | 'propfuel'
  | 'propfuel-darkmode'
  | 'pylon'
  | 'pylon-darkmode'
  | 'quiverai'
  | 'quiverai-darkmode'
  | 'resend'
  | 'resend-darkmode'
  | 'runpod'
  | 'runpod-darkmode'
  | 'same-darkmode'
  | 'same'
  | 'sazabi'
  | 'sazabi-darkmode'
  | 'scale-to-win'
  | 'scale-to-win-darkmode'
  | 'sfcompute'
  | 'sfcompute-darkmode'
  | 'slack-darkmode'
  | 'slack'
  | 'square'
  | 'square-darkmode'
  | 'standard-intelligence'
  | 'standard-intelligence-darkmode'
  | 'sst'
  | 'tomoai'
  | 'tomoai-darkmode'
  | 'trigger-dev'
  | 'trigger-dev-darkmode'
  | 'supermemory'
  | 'supermemory-darkmode'
  | 'superwall'
  | 'superwall-darkmode'
  | 'turbopuffer'
  | 'turbopuffer-darkmode'
  | 'typesafe-ai'
  | 'typesafe-ai-darkmode'
  | 'unkey'
  | 'unkey-darkmode'
  | 'vallor'
  | 'vallor-darkmode'
  | 'valon'
  | 'valon-darkmode'
  | 'vendora'
  | 'vendora-darkmode'
  | 'vetcove'
  | 'vetcove-darkmode'
  | 'vitalize'
  | 'vitalize-darkmode'
  | 'whatnot-darkmode'
  | 'whatnot'
  | 'whop-darkmode'
  | 'whop'
  | 'whydonate'
  | 'whydonate-darkmode'

export default function Logo({ name, ariaLabel, ...props }: Props) {
  const { viewBox } = manifest[name]

  // Use SVG <image> for logos that need direct rendering
  // (gradients, embedded images, etc. don't work with <use> from external sprites)
  if (manifest[name].needsDirectRender) {
    return (
      <svg {...props} viewBox={viewBox} aria-label={ariaLabel}>
        <image href={logoUrls[name]} width='100%' height='100%' />
      </svg>
    )
  }

  return (
    <svg {...props} viewBox={viewBox} aria-label={ariaLabel}>
      <use href={`${logos}#${name}`} />
    </svg>
  )
}
